import React, { useContext } from "react";
import HelpGuideText from "../../constants/help-guides.json";
import { Divider } from "antd";
import {
  Background,
  Card,
  Typography,
  OtpInputField,
  PrimaryButton,
  NavigationHeader,
  TextLink,
  CardLink,
  MainLayout,
} from "../../components";
import "./HelpPage.scss";
import { getPageTitle, pageTitle } from "../../constants/constants";
import { Helmet } from "react-helmet";
import { UserContext } from "../../storage/context";
import { HELP_PAGE_VIEW, trackEvent } from "../../analytics";

export default function HelpPage() {
  const { userProfile } = useContext(UserContext);
  trackEvent(HELP_PAGE_VIEW);
  return (
    <div>
      <Helmet>
        <title>{getPageTitle("HELP_PAGE", userProfile.environment)}</title>
      </Helmet>
      <Typography h1 style={{ marginBottom: "25px", fontWeight:"600" }}>
        Help
      </Typography>
      <div className="help-page-container">
        {HelpGuideText.map((helpGuide, i) => (
          <div className={`help-section section-${i}`}>
            <Typography h3 style={{ marginBottom: "11px" }}>
              {helpGuide.heading}
            </Typography>
            <div className="helping-card-container">
              {helpGuide.items.map((content, j) => (
                <CardLink
                  title={content.title}
                  description={content.description}
                  link={content.link}
                  backgroundColor={helpGuide.background_color}
                  className="individual-card"
                  event={content.event}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
